// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infinite-video-grid-column__ghost-element{visibility:hidden;width:261px;flex-grow:1}", ""]);
// Exports
module.exports = exports;
